/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { ExpediaSignatureParams } from '../../models/expedia-signature-params';
import { ExpediaSignatureResponse } from '../../models/expedia-signature-response';

export interface GenerateExpediaPartnerSignature$Params {
  orderId: string;
  hash?: string;
      body: ExpediaSignatureParams
}

export function generateExpediaPartnerSignature(http: HttpClient, rootUrl: string, params: GenerateExpediaPartnerSignature$Params, context?: HttpContext): Observable<DapiHttpResponse<ExpediaSignatureResponse>> {
  const rb = new DapiRequestBuilder(rootUrl, generateExpediaPartnerSignature.PATH, 'post');

  if (params) {
    rb.path('orderId', params.orderId, {});
    rb.query('hash', params.hash, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<ExpediaSignatureResponse>;
    }),
    catchErrorAsJson()
  );
}

generateExpediaPartnerSignature.PATH = '/api/v2/order/{orderId}/expedia-partner-signature';
